export const tableRows = [
  'Username',
  'First Name',
  'Last Name',
  'Created By',
  'Created At',
  'Email',
  'Action',
];
